import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import homePageStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'homePage'
const customImplement: CustomStoreImplementationOptions = homePageStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function homePageFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('home-page.title', 'Matchers, spécialiste de la formation pour start-up, TPE et PME'),
        $description: $translate('home-page.description', 'Bénéficiez de formations 100% financées. Matchers connecte votre entreprise avec les experts les plus qualifiés pour vous accompagner sans frais. '),
        $publishedTime: new Date('2023-02-13T07:42:17.391Z'),
        $modifiedTime: new Date('2023-12-13T09:45:07.213Z'),
        // Constants,
        $constants: {},
        // Data,
        $info: { domaines: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      jeMinscrisClick () {
        openUrl('/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      jeMinscrisClickOnSm () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      jeMinscrisClickOnXs () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      container7Click () {
        openUrl('/Experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      async container10Click () {
        await navigateTo({ name: 'Connexion' })
      },
      /* @ts-ignore: to allow override in your custom file */
      prendreRendezVousClick () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', undefined)
      },
      /* @ts-ignore: to allow override in your custom file */
      async container18Click () {
        await navigateTo({ name: 'hub-entreprise-Fonctionnement' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async container23Click () {
        await navigateTo({ name: 'hub-expert-Fonctionnement' })
      },
      /* @ts-ignore: to allow override in your custom file */
      button2Click () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', undefined)
      },
      /* @ts-ignore: to allow override in your custom file */
      button3Click () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', undefined)
      },
      /* @ts-ignore: to allow override in your custom file */
      button4Click () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', undefined)
      },
      /* @ts-ignore: to allow override in your custom file */
      button5Click () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', undefined)
      },
      /* @ts-ignore: to allow override in your custom file */
      button6Click () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', undefined)
      },
      /* @ts-ignore: to allow override in your custom file */
      button7Click () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', undefined)
      },
      /* @ts-ignore: to allow override in your custom file */
      button8Click () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', undefined)
      },
      /* @ts-ignore: to allow override in your custom file */
      button9Click () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', undefined)
      },
      /* @ts-ignore: to allow override in your custom file */
      async decouvrirLequipeClick () {
        await navigateTo({ name: 'Equipe' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async decouvrirLequipeClickOnXs () {
        await navigateTo({ name: 'Equipe' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return homePageFactory(storeId)()
}

export const homePageRaw = homePageFactory()
export const homePage = () => homePageRaw() as MergeCustomStore<typeof homePageStoreCustom.instance>
